export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-base_DE.9efd8ce5.png";